import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";

import ConfigLayout from "layout/configLayout";
import Layout from "layout/mainLayout";
import RequireAuth from "./RequireAuth";
import { BasicInfo } from "pages/admin/adminDetails/basicInfo";
import EmergencyAlerts from "pages/emergencyAlerts";
import Login from "pages/login";

import {
  AdditionalServiceInfo,
  Admin,
  BookingTimeline,
  AssociateBookings,
  BasicInformation,
  Conversations,
  Dashboard,
  Documentation,
  EmergencyAlertDetail,
  FamilyCare,
  Branches,
  WarehouseLocations,
  Feed,
  FeedCreate,
  KycInformation,
  LocationInformation,
  Locker,
  ManageAdmins,
  ManageManagers,
  PermissionMatrix,
  UserDetail,
  Users as ConfigUsers,
  PaymentInformation,
  PropertyCare,
  ServiceBookingDetails,
  ServiceBookingsLayout,
  ServiceCategory,
  ServiceDetail,
  ServiceFeed,
  CancellationRequestsTab,
  QuotationTab,
  SupportRequestsTab,
  ServiceInfo,
  ServiceInformation,
  ServicePackageDetail,
  ServicePackages,
  Services,
  ServiceType,
  ShopInIndia,
  ShopForYourself,
  UserDetails,
  UserFamily,
  UserInformation,
  UserProperty,
  VKinnectUsers,
  VolunteerDetails,
  Volunteers,
} from "./routeImports";

const RoutesContainer = () => {
  return (
    <Router>
      <Routes>
        <Route element={<RequireAuth />}>
          <Route path="/" element={<Layout />}>
            <Route index element={<Navigate to="service-bookings" />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="service-bookings" element={<ServiceBookingsLayout />}>
            <Route index element={<Navigate to="family-care" />} />
            <Route path="family-care" element={<FamilyCare />} />
            <Route path="property-care" element={<PropertyCare />} />
            <Route path="shop-in-india" element={<ShopInIndia />} />
          </Route>
          <Route
            path="service-bookings/details/:id"
            element={<ServiceBookingDetails />}
          >
            <Route index element={<Navigate to="service-information" />} />
            <Route path="service-information" element={<ServiceInfo />} />
            <Route path="timeline" element={<BookingTimeline />} />
            <Route
              path="additional-service-information"
              element={<AdditionalServiceInfo />}
            />
            <Route
              path="payment-information"
              element={<PaymentInformation />}
            />
            <Route
              path="cancellation-requests"
              element={<CancellationRequestsTab />}
            />
            <Route
              path="support-requests"
              element={<SupportRequestsTab />}
            />
            <Route path="quotation" element={<QuotationTab />} />
            <Route path="service-feed" element={<ServiceFeed />} />
          </Route>
          <Route path="vkinnect-feed" element={<Feed />} />
          <Route path="vkinnect-feed/create" element={<FeedCreate />} />
          <Route
            path="vkinnect-managers"
            element={<Volunteers type="MANAGER" title="Manager" />}
          />
          <Route path="vkinnect-associates" element={<Volunteers />} />
          <Route
            path="vkinnect-service-partners"
            element={<Volunteers type="CONTRACTOR" title="Service Partner" />}
          />
          <Route
            path="vkinnect-warehouse"
            element={
              <Volunteers type="WAREHOUSE" title="Warehouse Team member" />
            }
          />
          <Route path="vkinnect-users" element={<VKinnectUsers />} />
          <Route path="conversations" element={<Conversations />} />
          <Route path="vkinnect-users/details/:id" element={<UserDetails />}>
            <Route index element={<Navigate to="basic-information" />} />
            <Route path="basic-information" element={<UserInformation />} />
            <Route path="family-members" element={<UserFamily />} />
            <Route path="property-details" element={<UserProperty />} />
          </Route>
          <Route path="shop-for-yourself" element={<ShopForYourself />} />
          <Route path="emergency-alerts" element={<EmergencyAlerts />} />
          <Route
            path="emergency-alerts/:id"
            element={<EmergencyAlertDetail />}
          />
          <Route
            path="vkinnect-associates/details/:id"
            element={<VolunteerDetails />}
          >
            <Route index element={<Navigate to="basic-information" />} />
            <Route path="basic-information" element={<BasicInformation />} />
            <Route
              path="service-information"
              element={<ServiceInformation />}
            />
            <Route
              path="location-information"
              element={<LocationInformation />}
            />
            <Route path="kyc-information" element={<KycInformation />} />
            <Route path="documentation" element={<Documentation />} />
            <Route path="service-bookings" element={<AssociateBookings />} />
          </Route>
        </Route>
        <Route path="configuration" element={<ConfigLayout />}>
          <Route index element={<Navigate to="users" />} />
          <Route path="vkinnect-admin" element={<Admin />} />
          <Route path="users" element={<ConfigUsers />} />
          <Route path="users/:id" element={<UserDetail />} />
          <Route path="manage-admins" element={<ManageAdmins />} />
          <Route path="manage-managers" element={<ManageManagers />} />
          <Route path="permissions" element={<PermissionMatrix />} />
          <Route path="branches" element={<Branches />} />
          <Route
            path="warehouse-locations"
            element={<WarehouseLocations />}
          />
          <Route path="vkinnect-admin/:id" element={<BasicInfo />} />
          <Route path="service-category" element={<ServiceCategory />} />
          <Route
            path="service-category/:id/services"
            element={<ServiceType />}
          />
          <Route path="services" element={<Services />} />
          <Route path="services/:id" element={<ServiceDetail />} />
          <Route path="locker" element={<Locker />} />
          <Route path="service-packages" element={<ServicePackages />} />
          <Route
            path="service-packages/:id"
            element={<ServicePackageDetail />}
          />
        </Route>
        </Route>
        <Route path="login" element={<Login />} />
      </Routes>
    </Router>
  );
};

export default RoutesContainer;
